export default __webpack_public_path__ + "assets/images/1a50ac66f16369e7c887e32bf14666f5.jpg";